import { DestroyRef, Component, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';

import { trigger, transition, style, animate, state } from '@angular/animations';
import { ErrorHandlerService, AppError } from '../../services/error-handler.service';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-error-toast',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './error-toast.component.html',
  styleUrls: ['./error-toast.component.scss'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateX(100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class ErrorToastComponent implements OnInit {
  errors: AppError[] = [];
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);

  constructor(private errorHandler: ErrorHandlerService) {}

  ngOnInit(): void {
    this.errorHandler.getErrors()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(errors => {
        // Only show the last 5 errors
        this.errors = errors.slice(-5);
        this.cdr.markForCheck();
      });
  }
  dismissError(errorId: string): void {
    this.errorHandler.dismissError(errorId);
  }

  getToastClass(error: AppError): string {
    const baseClasses = 'alert shadow-lg';
    
    switch (error.severity) {
      case 'error':
        return `${baseClasses} alert-error`;
      case 'warning':
        return `${baseClasses} alert-warning`;
      case 'info':
        return `${baseClasses} alert-info`;
      case 'success':
        return `${baseClasses} alert-success`;
      default:
        return baseClasses;
    }
  }

  getIcon(error: AppError): string {
    if (error.severity === 'success') {
      return 'check_circle';
    }
    switch (error.type) {
      case 'network':
        return 'wifi_off';
      case 'auth':
        return 'lock';
      case 'server':
        return 'cloud_off';
      default:
        switch (error.severity) {
          case 'error':
            return 'error';
          case 'warning':
            return 'warning';
          case 'info':
            return 'info';
          default:
            return 'error';
        }
    }
  }
}